// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2jU7a","cell":"ColumnAccessor_cell__2L688","firstCellAccent":"ColumnAccessor_firstCellAccent__1Oge2"};